import { render, staticRenderFns } from "./profile-user.vue?vue&type=template&id=d315322e&scoped=true&"
import script from "./profile-user.vue?vue&type=script&lang=js&"
export * from "./profile-user.vue?vue&type=script&lang=js&"
import style0 from "./profile-user.vue?vue&type=style&index=0&id=d315322e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d315322e",
  null
  
)

export default component.exports